export default "__VITE_ASSET__C2tPI$vL__"